import c from './app-table.vue';

export default c;
